const AutoRehydrate = require("redux-persist").autoRehydrate;

const enhancers = (module.exports = [
    AutoRehydrate({
        log: !__PROD__
    })
]);

if (__DEBUG__) {
    const devToolsExtension = window.devToolsExtension;
    if (typeof devToolsExtension === "function") {
        enhancers.push(devToolsExtension());
    }
}



// WEBPACK FOOTER //
// ./src/wiring/enhancers.js